import React from "react";

const Content = ({ subtitle, list, body, link, onClick, className }) => (
  <div className={className}>
    {subtitle && <p className="font-bold text-lg pb-4">{subtitle}</p>}
    {list &&
      list.map(item => (
        <div className="mb-4">
          <p className="font-bold inline">{item.name}</p>
          <p className="inline"> {item.value}</p>
        </div>
      ))}
    {body && <p className="pb-4 text-gray-600">{body}</p>}
    {link ? (
      <button type="button" className="btn btn-green" onClick={onClick}>
        {link.text}
      </button>
    ) : (
      <button type="button" className="btn btn-green">
        Done
      </button>
    )}
  </div>
);

Content.defaultProps = {
  className: "bg-white w-full flex-1 relative z-20 px-4 py-8"
};

export default Content;
